"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactDocMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_entity_1 = require("./contact.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let ContactDocMap = class ContactDocMap {
    constructor(contactId, documentId) {
        this.contactId = contactId;
        this.documentId = documentId;
    }
};
exports.ContactDocMap = ContactDocMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], ContactDocMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], ContactDocMap.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "doc_id" }),
    tslib_1.__metadata("design:type", Number)
], ContactDocMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.contactDocMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactDocMap.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.contactDocMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "doc_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactDocMap.prototype, "document", void 0);
exports.ContactDocMap = ContactDocMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("contact_doc_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], ContactDocMap);
